const preloader = document.getElementById('preloader')

window.addEventListener("DOMContentLoaded", () => {
    preloader.classList.add('hide')
})